import React from 'react';
import * as S from './styled';
import TouchReel from '@resources/images/main/innovations/TouchReel.jpg';
import XTap from '@resources/images/main/innovations/X-Tap.jpg';
import Shower from '@resources/images/main/innovations/Shower.jpg';
import MultiDock from '@resources/images/main/innovations/MultiDock.jpg';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

const innovations = [
	{
		name: 'TouchReel',
		image: TouchReel,
		alt: 'Badezimmer | Artiviana 1956',
	},
	{
		name: 'X-Tap',
		image: XTap,
		alt: 'Badezimmer | Artiviana 1956',
	},
	{
		name: 'Shower Touch3 Cartridge',
		image: Shower,
		alt: 'Badezimmer | Artiviana 1956',
	},
	{
		name: 'MultiDock™',
		image: MultiDock,
		alt: 'Badezimmer | Artiviana 1956',
	},
];

export const Innovations = () => {
	const { t } = useTranslation();

	return (
		<S.InnovationsContainer>
			<S.Title>{t('main.innovations.title')}</S.Title>
			<S.InnovationsList
				slidesPerView="auto"
				breakpoints={{
					0: {
						spaceBetween: 20,
						centeredSlides: true,
						centeredSlidesBounds: true,
					},
					768: {
						spaceBetween: 40,
					},
				}}
			>
				{innovations.map((item, index) => (
					<S.InnovationsItem key={index}>
						<S.ImageWrapper>
							<Image width={350} height={350} src={item.image} alt={item.alt} />
						</S.ImageWrapper>
						<S.Text>{item.name}</S.Text>
					</S.InnovationsItem>
				))}
			</S.InnovationsList>
		</S.InnovationsContainer>
	);
};
